// src/api/executive/targets.api.tsx
import BaseAPI from 'api/api'
import type {
  BulkUpsertProcedureTargetsRequest,
  BulkUpsertProcedureTargetsResponse,
  BulkUpsertRevenueTargetsRequest,
  BulkUpsertRevenueTargetsResponse,
  GetAuditLogParams,
  GetAuditLogResponse,
  GetProcedureTargetsParams,
  GetProcedureTargetsResponse,
  GetRevenueTargetsParams,
  GetRevenueTargetsResponse,
} from './executive.types'

const path = 'dashboard-targets'

export default class TargetsApi extends BaseAPI {
  static async getRevenueTargets(params: GetRevenueTargetsParams): Promise<GetRevenueTargetsResponse> {
    const res = await BaseAPI.api.get(`${path}/revenue`, { params })
    return res.data
  }

  static async upsertRevenueTargets(body: BulkUpsertRevenueTargetsRequest): Promise<BulkUpsertRevenueTargetsResponse> {
    const res = await BaseAPI.api.post(`${path}/revenue`, body)
    return res.data as BulkUpsertRevenueTargetsResponse
  }

  static async deleteRevenueTarget(id: number): Promise<{ ok: true }> {
    const res = await BaseAPI.api.delete(`${path}/revenue/${id}`)
    return res.data
  }

  static async getProcedureTargets(params: GetProcedureTargetsParams): Promise<GetProcedureTargetsResponse> {
    const res = await BaseAPI.api.get(`${path}/procedure`, { params })
    return res.data
  }

  static async upsertProcedureTargets(body: BulkUpsertProcedureTargetsRequest): Promise<BulkUpsertProcedureTargetsResponse> {
    const res = await BaseAPI.api.post(`${path}/procedure`, body)
    return res.data as BulkUpsertProcedureTargetsResponse
  }

  static async deleteProcedureTarget(id: number): Promise<{ ok: true }> {
    const res = await BaseAPI.api.delete(`${path}/procedure/${id}`)
    return res.data
  }

  static async getAuditLog(params: GetAuditLogParams): Promise<GetAuditLogResponse> {
    const res = await BaseAPI.api.get(`${path}/history`, { params })
    return res.data
  }
}
